<template>
  <div class="login-box" style="position: relative;">
    <div class="title">
      <img src="@/assets/bmb-logo.png" />
      <div>验证码登录注册</div>
    </div>
    <div class="form">
      <div class="item">
        <input type="number" v-model="mobile" placeholder="请输入手机号" />
      </div>
      <div class="item">
        <input type="number" v-model="code" placeholder="请输入验证码" />
        <!-- <div class="vali-btn" @click.stop.prevent="getCode">{{valiBtn}}</div> -->
        <div class="vali-btn" @click.stop.prevent="aliCheck">{{valiBtn}}</div>
      </div>
    </div>
    <div class="prompt">未注册手机验证后自动注册</div>
    <div class="btn" @click="onSubmit">确认</div>
    <div class="agreement">
      <div class="checkbox">
        <van-checkbox v-model="checked" shape="square" icon-size="12px"></van-checkbox>
      </div>
      <div class="text" @click="checked = !checked">
        我已阅读并同意 <span @click.stop.prevent="goPrivacy">《隐私政策》</span>、<span @click.stop.prevent="goAgreement">《用户协议》</span> 并授权斑马邦使用该斑马邦账号信息(如昵称、头像) 进行统一管理
      </div>
    </div>
    <div id="captcha-element" style="position: absolute;top: 0;left: 0;"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Field, Form, Toast, Image as VanImage, Icon, CellGroup, Popup, Cell, Checkbox } from 'vant'
import { getCode, getProfile, loginByMobile } from "@/api/user";
import {setToken} from "@/libs/cookie-storage";
import { S365Util } from '@/utils/s365Util'
import {QNImageUtil} from "@/utils";
Vue.use(Field).use(Form).use(VanImage).use(Icon).use(CellGroup).use(Popup).use(Cell).use(Checkbox)

export default {
  data() {
    return {
      aliCaptcha: null,
      region: '+86',
      logo: '',
      redirect: '',
      mobile: '',
      code: '',
      valiBtn: '获取验证码',
      sendCodeDisabled: false,
      popupVisible: false,
      countryCodes: [
        { name: '中国大陆 (+86)', code: '+86' },
        { name: '中国台湾 (+886)', code: '+886' },
      ],
      checked: false
    }
  },
  created() {
    // 弹出式，除region和prefix以外的参数
    window.initAliyunCaptcha({
      // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "1jlcbdfz",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element",
      // 验证码验证通过回调函数
      success: (captchaVerifyParam) => {
        this.getCode(captchaVerifyParam)
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        console.log("出错了");
        console.log(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: (instance)=> {
        this.aliCaptcha = instance;
      },
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
      slideStyle: {
        width: 360,
        height: 40,
      }
    });
  },
  mounted() {
    this.redirect = this.$route.query.redirect
    if (S365Util.isInApp()) {
      this.logo = QNImageUtil.originView('FhVneyw0pMrHZgYR4oT1cPo7_8es')
    } else {
      this.logo = QNImageUtil.originView('FmrRsONDG8NJKfhs7dQ-Z348JMm0')
    }
  },
  methods: {
    aliCheck() {
      if (!this.checked) {
        Toast('请先阅读并同意《隐私政策》、《用户协议》')
        return
      }
      if (this.sendCodeDisabled) {
        return
      }
      if (!this.mobile) {
        Toast('请先输入手机号')
        return
      }
      this.aliCaptcha.show();
    },
    goPrivacy() {
      window.open('https://www.snsports.cn/m/bmb-privacy.html')
    },
    goAgreement() {
      window.open('http://www.snsports.cn/m/tos.html')
    },
    onSubmit() {
      if (!this.checked) {
        Toast('请先阅读并同意《隐私政策》、《用户协议》')
        return
      }
      const params = {}
      if (this.region === '+886') {
        params.loginName = '886-' + this.mobile
      } else {
        params.loginName = this.mobile
      }
      params.sendCode = this.code
      params.type = 'mobile'
      params.action = 'fastBind'
      loginByMobile(params).then(res => {
        const { data } = res
        getProfile({ passport: data.session.id })
        setToken(data.session.id)
        getProfile({ passport: data.session.id })
        window.localStorage.setItem('bm-match-h5-user', JSON.stringify(data.user))
        Toast('登录成功')
        this.$router.replace({ path: decodeURIComponent(this.redirect) })
      })
    },
    getCode(captchaVerifyParam) {
      if (!this.checked) {
        Toast('请先阅读并同意《隐私政策》、《用户协议》')
        return
      }
      if (this.sendCodeDisabled) {
        return
      }
      let params = {}
      if (!this.mobile) {
        Toast('请先输入手机号')
        return
      }
      params = {
        loginType: 'mobile',
        captchaVerifyParam: captchaVerifyParam,
        action: 'sendFastBindCode'
      }
      if (this.region === '+886') {
        params.mobile = '886-' + this.mobile
      } else {
        params.mobile = this.mobile
      }
      this.tackBtn()
      getCode(params).then(() => {})
    },
    tackBtn() {
      let time = 60
      this.valiBtn = '60秒后重试'
      this.sendCodeDisabled = true
      const timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          this.valiBtn = '获取验证码'
          this.sendCodeDisabled = false
        } else {
          this.sendCodeDisabled = true
          this.valiBtn = time + '秒后重试'
          time--
        }
      }, 1000)
    },
    showPopup() {
      this.popupVisible = true;
    },
    selectCountryCode(code) {
      this.region = code // 在选择国家代码后自动在输入框中添加空格
      this.popupVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box{
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0 28px;
  box-sizing: border-box;
  .title{
    margin-top: 70px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #3D3D3D;

    img{
      width: 150px;
      height: 85px;
      margin-bottom: 32px;
    }
  }
  .form{
    margin-top: 30px;
    .item{
      width: 319px;
      height: 42px;
      border-radius: 3px;
      background-color: #F6F6F6;
      display: flex;
      align-items: center;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      input{
        flex: 1;
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
      }
      .vali-btn{
        background: #C13842;
        width: 105px;
        height: 42px;
        border-radius: 0px 3px 3px 0px;
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        line-height: 42px;
      }
    }
  }
  .prompt{
    font-size: 12px;
    font-weight: 500;
    color: #B1B3B8;
  }
  .btn{
    width: 317px;
    height: 44px;
    border-radius: 22px;
    background: #C13842;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 26px;
  }
  .agreement{
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    font-weight: 500;
    margin-top: 20px;
    .checkbox{
      width: 40px;
      padding-top: 2px;
    }
    span{
      color: #74A3CC;
    }
    .text{
      // padding-left: 22px;
      color: #909399;
    }
  }
}
.mc-auth-login {
  .my-field {
    ::v-deep .van-field__body {
      display: flex;
      flex-flow: row-reverse;
    }
  }
}
</style>
